<!-- Interview -->
<template>
  <div class="apply-interview">
    <!-- <div class="interview-banner">
      <div>
        <h1>Starting time：2019–03-24 19:00:00</h1>
        <a :href="interviewInfos.zoom"
           target="_blank">Open Zoom</a>
      </div>
    </div> -->
    <!-- <div class="zoom-detail">
      <div class="zoom-detail-container">
        <div class="zoom-detail-right">
          <div class="zoom-detail-info">
            <h1>Interview</h1>
            <ul>
              <li>
                <p>Starting time：2019-03-22 16:00 (Eastern Standard Time)</p>
                <div>Expected discussion time：30mins</div>
              </li>
              <li v-show="isShow"></li>
              <template v-if="isShow">
                <li>
                  <p>1. Mentee proposed time (Eastern Standard Time)</p>
                  <div v-for="(item,index) in interviewInfos.changes"
                       :key="index">{{ `${item} ${index===0?'(priority)':''}` }}</div>
                </li>
                <li>
                  <p>2. Mentor confirmed time</p>
                  <div>2019-03-22 16:00 (Eastern Standard Time)</div>
                </li>
                <li>
                  <p>2. Mentor proposed time (Eastern Standard Time)</p>
                  <div>2019-03-24 19:00 - 20:00 (Most preferred)</div>
                  <div>2019-03-25 19:00 - 20:00</div>
                  <div>2019-03-25 19:00 - 20:00</div>
                </li>
                <li>
                  <p>2. CD withdrew time</p>
                  <div>2019-03-22 16:00 (Eastern Standard Time)</div>
                </li>
                <li>
                  <p>3. Mentee confirmed time</p>
                  <div>2019-03-22 16:00 (Eastern Standard Time)</div>
                </li>
              </template>
              <li :class="[isShow?'dis-64':'']">
                <span @click="isShow = !isShow">{{isShow?'Hide details':'Show details'}}</span>
              </li>
            </ul>
          </div>
          orange red green
          orange Please fill in the feedback
          green Appointment time has been confirmed
          <div class="zoom-detail-prompt orange">
            <span>Please fill in the feedback</span>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 提示 -->
    <div class="interview-prompt">
      <p>
        Thanks! If you’ve been selected for an interview, we will reach out to you soon via wechat or email :)
      </p>
    </div>
    <!-- 讨论区 -->
    <div class="zoom-dicuss"
         style="display:none;">
      <div>
        <div class="zoom-dicuss-con">
          <zlr-discuss title="Discussion">
            <template v-if="discussList&&discussList.length>0">
              <zlr-discuss-item v-for="(item, index) in discussList"
                                :key="index"
                                :avatar="item.role === 'USER'? mentorAvatar:ZlrLogo"
                                :name="item.sendName"
                                :time="item.sendTime"
                                :content="item.content"></zlr-discuss-item>

            </template>
            <template v-else>
              <no-content></no-content>
            </template>
          </zlr-discuss>
        </div>
      </div>
    </div>
    <!-- 发表讨论 -->
    <div class="mentee-zoom-add-dicuss"
         style="display:none;">
      <div>
        <div>
          <discuss-add title="Add discussion"
                       v-model="discuss"
                       :avatar="userAvatar"
                       ref="addDiscuss">
            <div class="dicuss-btn">
              <Button class="zlr-btn-default"
                      @click="backHandle">Back</Button>
              <Button class="zlr-btn-primary"
                      @click="sendHandle"
                      :loading="isSub">Send</Button>
            </div>
          </discuss-add>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { applyMentorDiscuss } from '@/api/apply'

// images
import mentorAvatar from '@/assets/images/home/mentor-avatar.svg'
import ZlrLogo from '@/assets/msp.svg'
// components
import discuss from '_c/discuss'
import DiscussAdd from '_c/discuss-add/discuss-add'
import NoContent from '_c/empty/empty'
// mixins
import back from './back'
// constant
import { promptInput } from '@/constant'
import { mapState } from 'vuex'
export default {
  name: 'apply-em-interview',
  mixins: [back],
  components: {
    ZlrDiscuss: discuss.ZlrDiscuss,
    ZlrDiscussItem: discuss.ZlrDiscussItem,
    DiscussAdd,
    NoContent
  },
  props: {
    value: {
      default: ''
    },
    mentorData: {
      default () {
        return {
          discuss: []
        }
      }
    }
  },
  computed: {
    ...mapState({
      'userAvatar' (state) {
        return state.user.userAvatar
      }
    }),
    discussList () {
      return this.mentorData.discuss
    },
    interviewInfos () {
      return this.mentorData.interviewInfos
    }
  },
  data () {
    return {
      mentorAvatar,
      ZlrLogo,
      isShow: false,
      isSub: false,
      discuss: '',
      promptInput
    }
  },
  mounted () {

  },
  methods: {
    // 保存
    sendHandle () {
      if (!this.discuss) {
        this.$zlr_message(this.promptInput, 'error')
        return false
      }
      let data = {
        applyId: this.value,
        discuss: {
          content: this.discuss
        }
      }
      this.isSub = true
      applyMentorDiscuss(data).then(res => {
        this.$emit('on-success')
        this.$refs['addDiscuss'].resetHtml()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(res => {
        this.isSub = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
